module.exports = "<div>\r\n  <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">{{$ctrl.title}}</div>\r\n    <div class=\"panel-body\">\r\n      <div class=\"no-data\" ng-hide=\"$ctrl.data.length\">No data to display</div>\r\n      <div id=\"{{$ctrl.chartContainerId}}\" ng-show=\"$ctrl.data.length\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/leadMonitor/enquiriesExpenditure/enquiriesExpenditure.html
// module id = 1847
// module chunks = 0